var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1920",
    width: 120,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1920v1920h-1920z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(924,581)",
    d: "m0 0h38l25 3 27 5 27 7 29 10 25 11 25 13 17 11 12 8 12 9 13 10 16 15 17 17 9 11 12 15 11 16 10 16 12 22 8 16 8 19 9 25 7 24 6 28 4 27 1 18v26l-2 22-1 22 8-7 16-13 17-13 11-7 5-2 6 1 8 5 1 1-1 8-9 10-10 10-8 7-10 10-7 8-13 14-7 8-8 10-10 12-12 16-9 15-16 25-15 24-14 22-9 14-16 29-14 29-15 37-13 35-13 36-8 17-7 9-9 9-10 5-9-2-10-4-8-7-9-9-11-17-8-14-15-28-5-10-16 2-16 4-30 5-21 1h-15l-23-1-17-2-17-3-28-7-26-8-29-12-16-8-22-12-27-18-17-13-15-13-17-16-13-14-11-14-13-18-12-19-14-25-9-19-12-31-8-27-6-29-3-29v-44l2-28 3-22 8-35 10-30 11-26 14-27 11-17 9-13 8-10 7-9 12-14 11-12 14-13 11-9 16-13 14-10 22-14 27-14 25-10 23-8 28-7 27-5z",
    fill: "#3CA587"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(934,744)",
    d: "m0 0 9 1 9 4 6 7 4 13 5 5 25 6 25 10 19 9 12 6 5 5v6l-8 16-10 15-10 19-8 9-4-1-15-10-16-8-14-5-11-2v15l1 36 2 3 24 8 14 5 25 12 12 8 11 9 11 14 8 16 4 16 1 11v13l-4 18-9 21-12 17-7 8-13 9-22 10-12 4-21 5-15 3 1 11 3 9v18l-8 4-11 3-15 1-10-3-5-3-3-6v-19l1-14-17-5-22-5-27-8-32-12-18-10-8-7-2-4 1-7 6-10 8-11 9-15 11-14 4-3 6 1 22 11 14 8 20 9 19 7 5-1 1-5v-48l-3-3-16-4-27-9-18-8-16-11-13-12-11-15-6-14-4-16v-26l4-18 5-14 9-14 9-10 10-9 11-7 12-6 23-8 14-3h11l1-7 5-10 6-7 7-4z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1358,965)",
    d: "m0 0 6 1 8 5 1 1-1 8-9 10-10 10-8 7-10 10-7 8-13 14-7 8-8 10-10 12-12 16-9 15-16 25-15 24-14 22-9 14-16 29-14 29-15 37-13 35-13 36-8 17-7 9-9 9-10 5-9-2-10-4-8-7-9-9-11-17-8-14-15-28-7-13-4-9-5-14-9-17-7-10-10-13-8-11-10-13-11-15-3-6-1-10 2-7 1-1h7l12 6 14 11 44 44v2l4 2 7 8 13 16 8 9 9 11 5 4 5 1 3-10 12-23 18-30 12-18 12-17 10-14 13-18 13-16 12-16 13-16 11-14 9-11 8-9 7-8 9-10 7-8 13-14 7-8 11-13 14-13 14-11 15-12 14-9z",
    fill: "#A6BA40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,992)",
    d: "m0 0h9l10 4 7 6 3 7-1 9-6 12-6 5-6 2h-8l-3-3-1-3-1-17-1-7v-11z",
    fill: "#3CA587"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(896,845)",
    d: "m0 0 8 1 5 4 1 2v10l-1 2-1 21-2 6-2 2h-7l-9-6-8-13v-11l3-7 6-7z",
    fill: "#3CA587"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1328,1022)",
    d: "m0 0v3l-13 14-7 8-8 10-10 12-12 16-9 15-16 25-15 24-14 22-9 14-8 14-1-2 14-27 8-14 18-30 10-15 13-19 10-14 10-13 9-10 9-11 15-16z",
    fill: "#3CA587"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1328,1022)",
    d: "m0 0v3l-7 8-2-2z",
    fill: "#47A780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarTick);
export default __webpack_public_path__ + "static/media/dollar_tick.1896df64b387b75422146e2822db6919.svg";
export { ForwardRef as ReactComponent };